import { render } from "./ViewAuditTrailDialog.vue?vue&type=template&id=1881b600&scoped=true"
import script from "./ViewAuditTrailDialog.vue?vue&type=script&lang=js"
export * from "./ViewAuditTrailDialog.vue?vue&type=script&lang=js"

import "./ViewAuditTrailDialog.vue?vue&type=style&index=0&id=1881b600&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1881b600"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn});qInstall(script, 'directives', {ClosePopup});
